import { render } from "./InsuranceLogs.vue?vue&type=template&id=31299763"
import script from "./InsuranceLogs.vue?vue&type=script&lang=js"
export * from "./InsuranceLogs.vue?vue&type=script&lang=js"

import "./InsuranceLogs.vue?vue&type=style&index=0&id=31299763&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/insurances/InsuranceLogs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "31299763"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('31299763', __exports__)) {
    console.log('reload')
    api.reload('31299763', __exports__)
  }
  
  module.hot.accept("./InsuranceLogs.vue?vue&type=template&id=31299763", () => {
    console.log('re-render')
    api.rerender('31299763', render)
  })

}


export default __exports__